module.exports = __webpack_public_path__ + "img/09b-days-modal.9789e4bf.png";